import React from 'react';
import { LoadingSpinner } from 'edenred-ui';
import { FormProvider } from 'react-hook-form';

import { ITopup } from '@epi-models/pages/TransferPage';

import { useTopup, useAdminTopupFormContext } from '../../hooks';
import { TopupUnavailable } from '../Topup/TopupUnavailable';

import { AdminTopupForm } from './AdminTopupForm';

export const AdminTopup = ({ updateFooter }: ITopup) => {
  const { hasLoadableBenefit, isLoading, activeBenefits } = useTopup();
  const { form } = useAdminTopupFormContext();

  if (isLoading) return <LoadingSpinner />;

  if (hasLoadableBenefit)
    return (
      <FormProvider {...form}>
        <AdminTopupForm
          updateFooter={updateFooter}
          form={form}
          loadableBenefits={activeBenefits}
        />
      </FormProvider>
    );

  return <TopupUnavailable />;
};
